import { slugRequest } from '../slugRequest';
import {
  ingameTestBaseUrl as testUrl,
  ingameBaseUrl as baseUrl,
  gzhBaseUrl,
  gzhTestBaseUrl,
} from '@/config/api';

// 获取个人用户信息包含马拉松距离
export function getUserInfo() {
  const path = '/php/ingame/usercenter/user_info.php';

  const config: ApiTypes.HttpRequestByJsonpConf = {
    isAuth: true,
    source: 'backEnd',
    type: 'jsonp',
    testUrl: `${testUrl}${path}`,
    url: `${baseUrl}${path}`,
    underlizeQuery: true,
    query: {
      game: 'gp',
      gift_type: 5000003,
    },
  };
  return slugRequest(config);
}

// 用户登录
export function actUserLogin() {
  const path = '/php/ingame/usercenter/user_login.php';

  const config: ApiTypes.HttpRequestByJsonpConf = {
    testUrl: `${testUrl}${path}`,
    url: `${baseUrl}${path}`,
    isAuth: true,
    source: 'backEnd',
    type: 'jsonp',
    underlizeQuery: true,
    query: {
      game: 'gp',
    },
  };
  return slugRequest(config);
}

export function saveUserProfile(nickname?: string) {
  const path = '/php/ingame/usercenter/save_user_profile.php';

  const config: ApiTypes.HttpRequestByJsonpConf = {
    testUrl: `${testUrl}${path}`,
    url: `${baseUrl}${path}`,
    isAuth: true,
    source: 'backEnd',
    type: 'jsonp',
    underlizeQuery: true,
    query: {
      bid: 'ingame',
      game: 'gp',
      nickname,
    },
  };

  return slugRequest(config);
}

export function queryUserRoleName(appid: string, openid: string, data) {
  const path = '/sidip/open/role/query';

  const config = {
    testUrl: `${gzhTestBaseUrl}${path}`,
    baseUrl: `${gzhBaseUrl}`,
    path,
    source: 'backEnd',
    method: 'POST',
    type: 'api',
    underlizeQuery: true,
    isAuth: true,
    query: {
      login_type: 'sop',
      sop_appid: 'gp',
      bid: 'game',
      src_appid: appid,
      src_openid: openid,
      uid: openid,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  };

  return slugRequest(config);
}


export function queryUserRoleNameNew(area: number, amsAcctype: string) {
  const path = '/ingamego/userinfo/userbase/query_role';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      game: 'cjm',
      area,
      ams_acctype: amsAcctype,
      is_trust: 1,
      is_force: 1,
    },
  };

  return slugRequest(config);
}
